<template src="./InputDateTimeNormal.html"></template>

<script>
export default {
  name: 'InputDateTimeNormal',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: String,
      required: false,
      default: () => ''
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ''
    },
    errorText: {
      type: String,
      required: false,
      default: () => ''
    },
    isError: {
      type: Boolean,
      required: false,
      default: () => false
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
    min: {
      type: String,
      required: false,
      default: () => ''
    },
  },
  created() {
    if (this.valueDefault) {
      this.value = this.valueDefault
    }
  },
  data() {
    return {
      value: '',
      distanceWithLabel: '0px',
    }
  },
  watch: {
    value() {
      this.$emit('inputValue', this.value)
    },
    valueDefault() {
      this.value = this.valueDefault
    },
    errorText() {
      this.distanceWithLabel = (this.$refs.labelForm?.offsetWidth || 0) + 10 + 'px'
    }
  },
  methods: {
    onBlur() {
      this.value = this.value.trim();
      if (this.required) {
        this.$emit('blur', this.value)
      }
    }
  }
}
</script>

<style lang="scss">
.error-text {
  color: red;
  margin: 0;
}
.is-error {
  border: 1px solid red;
}
</style>
